module.exports = __webpack_public_path__ + "986af74620ad4992bca7a5dba8620b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/header.jpg
// module id = 305
// module chunks = 0